export const createHash = (value: string | Array<string> | object): number => {
  let _value = value;

  if (typeof value !== 'string') {
    if (typeof value === 'object' && !Array.isArray(value)) {
      _value = JSON.stringify(value);
    } else {
      _value = value.toString();
    }
  }

  let hash = 0,
    i,
    chr;

  if (Array.isArray(_value) && _value.length === 0) {
    return hash;
  }

  if (typeof _value === 'string') {
    for (i = 0; i < _value.length; i++) {
      chr = _value.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0;
    }
  }

  return hash;
};
